import { FindCssRenderCommand, PermissionAccess, PermissionVisibility, StaticFeatureEnum, StyleVO } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { CONFIRMATION_MODE, CONFIRMATION_RESULT, WizMathUtils, WizStringUtils, WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  WizDatasource,

  WizGroupCommand,
  WizPopUp,
  WizRoot,
  WizTextInput,
  WizTranslationBasic,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizVgroup,
  WizIcon,
  WizEventManager, WizEvent,
  WizTextarea
} from '@wizeoo/akm-component-lib';
import { MultiDisplay, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';
import { CssRenderVO } from '@wizeoo/akm-common-lib';
/**
 * Vue de gestion des rendus CSS
 * Author LMA
 */
@Component({
  selector: 'cssrender-view',
  templateUrl: './cssrender.view.html',
})
export class CssRenderView extends BaseView {
  @ViewChild('mdMain') mdMain: MultiDisplay<StyleVO>; // grid principal

  @ViewChild('tiCode', { read: WizTextInput }) tiCode: WizTextInput; // champ de saisie du code
  @ViewChild('tiVisionCode', { read: WizTextInput }) tiVisionCode: WizTextInput; // champ d'affichage de la vision
  /** Composant de saisie de la description */
  @ViewChild('trsLabel', { read: WizTranslationBasic }) trsLabel: WizTranslationBasic;
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic;

  @ViewChild('vgEdition', { read: WizVgroup }) vgEdition: WizVgroup; // ensemble de la zone de détail pour écoute ModelUpdate
  @ViewChild('vgEdition', { read: WizValidationContainerDirective, static: false })
  private vgEditionCheck: WizValidationContainerDirective; // Zone de validation globale

  @ViewChild('taCss', { read: WizTextarea }) taCss: WizTextarea; // champ de saisie de la regexp
 
  /** Bouton d'ajout */
  @ViewChild('btnCreate', { read: WizIcon }) btnCreate: WizIcon;
  /** Bouton d'export */
  @ViewChild('btnExport', { read: WizIcon, static: false }) btnExport: WizIcon;
  /** Bouton d'import */
  @ViewChild('btnImport', { read: WizIcon, static: false }) btnImport: WizIcon;
  /** Bouton de suppression */
  @ViewChild('btnRemove', { read: WizIcon, static: false }) btnDelete: WizIcon;

  public currentCssRender: CssRenderVO = null; // sélection active (objet métier vrai)
  public clone: CssRenderVO = null; // clone de travail



  /** Constructeur */
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  /** DS du grid principal */
  public mainDS: WizDatasource<CssRenderVO> = new WizDatasource<CssRenderVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();


  /** Configuration du mode multi display (principal) */
  public mainConfig: MultiDisplayConfig<CssRenderVO> = {
    model: Model.getInstance(),
    datasource: this.mainDS,
    defaultMode: 'grid',
    onSelectionChanging: this.askSelectMain.bind(this),
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.common.code.$', width: 80, sortable: true, field: 'code', tooltipField: 'code' },
        { headerName: '$.common.vision.$', width: 80, sortable: true, field: 'vision', tooltipField: 'vision' },
        { headerName: '$.common.label.$', flex: 1, sortable: true, field: 'trsLabel', tooltipField: 'trsLabel' },
      ],
    },
    filter: {
      enabled: true,
      initFilter: this.initMainFilter.bind(this),
    },
  };

  /* #############################################################
                      CYCLE DE VIE
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const commands = [];
    // chargement de la liste des formats
    // chargement de la liste des rendus css
    if (!Model.getInstance().styleEngine.getCssRenderList()) {
      commands.push(new FindCssRenderCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }
    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands, null, false);
    } else {
      return null;
    }
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {

    super.managePermissions([
      {
        feature: StaticFeatureEnum.CSSRENDER,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnDelete,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    this.mainFilter.configure(['code', 'vision'], null, null); // alimentation du filtre principal
    this.mainDS.setSource(Model.getInstance().styleEngine.getCssRenderList()); // alimentation de la liste principale
    this.tiCode.wizRestrict = ViewData.ALPHANUMERIC_REGEXP;
    // TODO collecte du contexte pour currentStyle
    this.feed();
  }

  /** alimentation de la zone de détail */
  private feed(): void {
    // TODO ici gestion des permissions

    this.vgEdition.visible = !!this.clone;

    if (!!this.clone) {
      this.tiCode.wizValue = this.clone.code; // alimentation du code
      this.trsLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.labelVO);
      this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.descriptionVO);

      this.taCss.wizValue = this.clone.css; // alimentation du format

      if (this.clone.exist) {
        this.tiCode.wizDisabled = true;
      } else {
        this.tiCode.wizDisabled = false;
        setTimeout(() => {
          // sinon, pas le temps de rendre les compos enabled
          this.tiCode.wizFocus();
        }, 0);
      }
    }
  }

  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    super.wizAddListener();
    WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel); // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);
  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);
  }

  /** fonction de suppression du format */
  public mayDelete(): boolean {
    return !this.cantDelete || !!this.currentCssRender;
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableButtons(): boolean {
    return !ViewData.wizUpdateModel;
  }

  /* #############################################################
                  gestion sélection et filtres
     ############################################################# */

  private mainFilter: FilterComponent; // filterCompo du mdMain
  /** init du filter du mdMain */
  private initMainFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /** demande de changement de sélection */
  private askSelectMain(e: WizEvent = null): void {
    const vo: CssRenderVO = e.value;
    if (ViewData.wizUpdateModel) {

      e.preventDefault(); // sélection pas self && modifs en cours

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelect.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        vo,
        null,
        null
      ).show();
    } else {
      if (!this.mainDS.isSelected(vo)) {
        // pas encore sélectionné
        this.doSelect(vo);
      } else {
        // déjà sélectionné, déselection
        this.doSelect(null);
      }
    }
  }

  /**
   * Confirmation de la sélection du CssRenderVO
   */
  private confirmSelect(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const vo: CssRenderVO = result.data;
      this.mainDS.toggle(vo); // on a prevent l'event, on joue l'action
      this.doSelect(vo);
    }
  }

  /**
   * Changement de CssRenderVO sélectionné
   * @param pEvent WizEvent
   */
  private doSelect(vo: CssRenderVO) {
    ViewData.wizUpdateModel = false;
    if (vo) {
      this.currentCssRender = vo;
      this.clone = Model.getInstance().styleEngine.cloneCssRender(this.currentCssRender);
    } else {
      this.currentCssRender = null;
      this.clone = null;
    }
    this.feed();
  }

  /**
   * Changement de FormatVO sélectionné
   * @param pEvent WizEvent
   */
  public doCancel() {
    ViewData.wizUpdateModel = false;
    this.clone = Model.getInstance().styleEngine.cloneCssRender(this.currentCssRender);
    this.feed();
  }

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.CSSRENDER);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.CSSRENDER);
        break;
    }
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    // Juste besoin de rafraichir les données spécifiques au domain/bu courant
    if (e && e.data === BATCH_KIND.CSSRENDER) {
      new FindCssRenderCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode).configure(this.backFromReload.bind(this)).execute();
    }
  }

  private backFromReload(e: any): void {
    this.wizSynchronizeData();
  }

  /** création nouveau style */
  public askForAdd(): void {
    this.currentCssRender = Model.getInstance().styleEngine.buildFakeCssRender();
    this.clone = Model.getInstance().styleEngine.cloneCssRender(this.currentCssRender);
    this.mainDS.clearSelection();
    this.feed();
  }

  /** demande de suppression */
  public askForDelete(): void {
    WizPopUp.confirm(
      '$.common.delete.title.$',
      '$.common.delete.detail.$',
      this.doRemove.bind(this),
      CONFIRMATION_MODE.CONFIRM_CANCEL,
      this.currentCssRender
    ).show();
  }

  /**
   * Suppression
   * @param result Objet de retour sur popUp de confirmation. Contient l'action choisie, et la data d'origine
   */
  private doRemove(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      Model.getInstance().styleEngine.removeCSS(this.clone, this.currentCssRender, this.backFromMerge.bind(this));
    }
  }

  /**
   * Validateur d'unicité du code / shortCode
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le _clone est null
      if (!this.clone) {
        return null;
      }
      if (this.tiCode.wizValue !== null && this.tiCode.wizValue && this.tiCode.wizValue.length > 0) {
        // CHRONO = mot réservé
        if (this.tiCode.wizValue.toUpperCase() === 'CHRONO') {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }

        // Recherche d'une autre style avec le même code
        let otherCss: CssRenderVO = null;
        if (!!Model.getInstance().styleEngine.getCssRenderMap()?.has(this.clone.vision)) {
          // check map existe
          otherCss = Model.getInstance().styleEngine
            .getCssRenderMap().get(this.clone.vision)
            .get(this.tiCode.wizValue.toUpperCase());
        }

        // Si un style existe deja avec le meme code on affiche le message
        if (otherCss && otherCss.uid !== this.clone.uid) {
          const temp: WizValidationError = {
            wizError: '$.cssrender.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * modification d'un élément de modèle
   * @param e WizEvent
   */
  private updateModel(e: WizEvent): void {
    switch (e.component) {
      case this.tiCode:
        const text: string = this.tiCode.wizValue;
        this.clone.code = text;
        break;
      case this.trsLabel:
        this.clone.labelVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.trsDesc:
        this.clone.descriptionVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.taCss:
        this.clone.css = this.taCss.wizValue;
        break; 
    }
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  /** persistence sur save */
  public doMerge(): void {
    const errors = this.vgEditionCheck.check(true, true);
    if (!errors || (!!errors && errors.length === 0)) {
      Model.getInstance().styleEngine.mergeCSS(this.clone, this.currentCssRender, this.backFromMerge.bind(this));
    } else {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Callback sur retour de persistence
   * @param bddBack style créé ou modifié ou supprimé
   * @param operation CUD
   */
  private backFromMerge(vo: CssRenderVO, operation: EM_ACTION): void {

    this.mainDS.refresh();
    this.mainDS.clearSelection();
    this.currentCssRender = null;
    this.clone = null;
    this.feed();
  }

  /**
   * Est-ce que l'utilisateur peut créer ?
   * @returns 
   */
  public get cantCreate(): boolean {
    return !Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.CSSRENDER);
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantUpdate(): boolean {
    return !Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.CSSRENDER);
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantDelete(): boolean {
    return !Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.CSSRENDER);
  }


  public get injectClass(): string {
    let myclass: string = 'voidme';
    if(!!this.clone) {
      myclass = this.clone.code;
    }
    return myclass;
  }

  public applyCss(): void {
    Model.getInstance().styleEngine.cssMaker(this.clone);
  }


}
